import {
	db,
	getVipCapabilityTypeLabel,
	IModel,
	IVIPCapabilityBase,
	settings,
	VIPCapabilityBase,
	VIPCapabilityEvent,
	VipCapabilityStatus,
	IpRuleType,
} from "@/loader";
import dayjs, { Dayjs } from "dayjs";
import { Duration } from "dayjs/plugin/duration";

/**
 * Capability Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.16.0
 * @since		1.0.0
 */
export interface IVIPCapability extends IVIPCapabilityBase {
}

/**
 * Capability Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.16.0
 * @since		1.0.0
 */
export class VIPCapability extends VIPCapabilityBase implements IVIPCapability, IModel<IVIPCapability> {
	constructor (data: IVIPCapability = {}) {
		super(data);
	}

	public load(data: IVIPCapability) {
		super.load(data);
	}

	public update(data: IVIPCapability) {
		super.update(data);
	}

	/**
	 * Get Capability events
	 */
	public get events(): VIPCapabilityEvent[] {
		return db.capabilityEvents.list
			.filter(x => x.fk_capability === this.id)
			.sort((a, b) => a.event && b.event && b.event.date.diff(a.event.date) || b.fk_event - a.fk_event);
	}

	public get lastEvent(): VIPCapabilityEvent | null {
		return this.events?.[0] || null;
	}

	/**
	 * Get the short Type label
	 *
	 * @return string
	 */
	public getShortTypeLabel(): string {
		return getVipCapabilityTypeLabel(this.type).substr(0, 1);
	}

	public get canExtend(): boolean {
		return this.isTypeCustomary ? settings.customary_has_extension : settings.probationary_has_extension;
	}

	public get duration(): number {
		return this.isSigned || this.isExpired || this.isArchived
			? this.isTypeCustomary
				? settings.customary_duration
					+ (this.canExtend && this.extension ? settings.customary_extension_duration : 0)
				: settings.probationary_duration
					+ (this.canExtend && this.extension ? settings.probationary_extension_duration : 0)
			: 0;
	}

	public get end(): Dayjs | null {
		return this.date ? this.date.add(this.duration, "years").subtract(1, "day").endOf("day") : null;
	}

	public get isActive(): boolean {
		return this.isSigned && this.date?.isBefore(dayjs()) && this.end?.isAfter(dayjs()) || false;
	}

	public get isExpired(): boolean {
		return this.status === VipCapabilityStatus.expired || (this.isSigned && this.end?.isBefore(dayjs())) || false;
	}

	public get isRenewable(): boolean {
		return this.isActive && this.end && this.end.diff(dayjs(), "months", true) <= settings.renew_limit || false;
	}

	public get ago(): Duration | null {
		return this.date ? dayjs.duration(this.date.diff(dayjs())) : null;
	}

	public get rule(): IpRuleType {
		return this.isTypeCustomary ? this.ip?.exceptional ? "exceptional" : "customary" : "probationary";
	}

	public get ip_code(): string {
		return this.ip?.code.toString() || "";
	}

	public toString(): string {
		return [this.ip_code, this.getShortTypeLabel()].filter(x => !!x).join("-");
	}
}
